import React from 'react'
import { AlertTriangle } from 'lucide-react'

const SensorBadge = ({ label }: { label: string }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '8px' }}>
        <AlertTriangle size={13} color="#E5D34A" strokeWidth={2} style={{ flexShrink: 0 }} />
        <span style={{ fontFamily: 'Nunito', fontSize: '12px', fontWeight: 300, color: 'rgba(255,255,255,0.6)' }}>
            {label}
        </span>
    </div>
)

export default SensorBadge
